<template>
    <div class="tableDesign">
        <table :class="lightMood === true ? 'table table-striped' : 'table'">
            <thead>
                <tr>
                    <th v-for="(th, idx) in thead" :key="idx"
                        v-if="model === 'score' || model === 'userScoreIndividual' || model === 'usersTeamsScore'"
                        @mouseenter="getTitleOfThead(th)">
                        <p class="product-details">{{th}}</p>
                        <span class="product-details-full">{{th}}</span>
                    </th>
                    <th v-for="(th, idx) in thead" v-else :style="{ width: getColumnWidth(th) }">
                        {{th}}
                    </th>
                    <th class="Actions_" :class="{ 'wide-action-col': isFourActionsVisible }" >
                        Actions
                        <!-- <button class="btnSort" @click.prevent="sortOrganziation">
                            <img src="../../assets/images/arrowUpDown.png" alt="">
                        </button> -->
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(td, idx) in tbody" :key="td.id"
                    :style="this.model === 'score' && (td.score === 'Not Published' || td.score === 'Not Solved') ? 'opacity:0.2' : 'opacity:1'">
                    <td v-for="key in keys" v-if="model === 'competitions' && this.role !== 'user'">
                        <router-link to="" @click.prevent="goToViewCompetition(td)">
                            {{td[key]}}
                        </router-link>
                    </td>

                    <td v-for="key in keys" v-else-if="model === 'trainings' && this.role !== 'user'">
                        <router-link to="" @click.prevent="goToViewTraining(td)">
                            {{key === 'start_date' ? dateTime(td['start_date']) : td[key] }}
                        </router-link>
                    </td>

                    <td v-for="key in keys" v-else-if="model === 'trainings'">
                        {{key === 'start_date' ? dateTime(td['start_date']) : td[key] }}
                    </td>
                    <td v-for="key in keys" v-else-if="model === 'scoreIndividual'">
                        {{td[key]}}
                    </td>
                    <td v-for="key in keys" v-else-if="model === 'scoreTeams'">
                        {{td[key]}}
                    </td>
                    <td v-for="key in keys" v-else-if="model === 'teamsScoreCompetition'">
                        <!--                    {{td}}-->
                        {{key === 'score' ? td[key] === null ? 0 + ' / ' + td['totalWeight'] : td[key] + ' / ' +
                        td['totalWeight'] : td[key]}}
                    </td>

                    <td v-for="key in keys" v-else-if="model === 'score'" class="position-relative overflow-visible">

                        <p class="product-details"> {{

                            key === 'score'
                            ? (
                            ( typeof td[key] === 'number') ? td[key] === null
                            ? ( 0 + ' / ' + td['totalWeight'])
                            : (td[key] + ' / ' + td['totalWeight']) : td[key]

                            )
                            :
                            td[key]
                            }}</p>
                        <span class="product-details-full">{{key === 'score'
                            ? (
                            ( typeof td[key] === 'number') ? td[key] === null
                            ? ( 0 + ' / ' + td['totalWeight'])
                            : (td[key] + ' / ' + td['totalWeight']) : td[key]

                            )
                            :
                            td[key]}}
                        </span>

                    </td>
                    <td v-for="key in keys" v-else-if="model === 'userScoreIndividual'">
                        <span v-if="key === 'score' && td[key] === 0">{{td[key] === null ? 0 + ' / ' + td['totalWeight']
                            : td[key] + ' / ' + td['totalWeight']}}</span>
                        <span v-else-if="key === 'score'">{{td[key] === null ? 0 + ' / ' + td['totalWeight'] : td[key] +
                            ' / ' + td['totalWeight']}}</span>
                        <span v-else>{{td[key]}}</span>
                    </td>
                    <td v-for="key in keys" v-else-if="model === 'usersTeamsScore'">
                        {{key === 'score' ? td[key] === null ? 0 + ' / ' + td['totalWeight'] : td[key] + ' / ' +
                        td['totalWeight'] : td[key]}}
                    </td>
                    <td v-for="key in keys" v-else-if="model === 'roles'">
                        {{key === 'name' ? td['name'].replace(/[0-9]/g, '').replace('super_admin', '') : td[key]}}
                    </td>
                    <td v-for="key in keys" v-else-if="model === 'teams'">
                        <span v-if="key === 'user' && td['user'] === null">No Leader</span>
                        <span v-else-if="key === 'user'">{{td['user'] !== null ? td['user'].name : td[key]}}</span>
                        <span v-else>{{td[key]}}</span>
                    </td>
                    <td v-for="key in keys" v-else>{{key === 'user_id' ? td[key].email : td[key]}}</td>
                    <td class="aciton-body-cell">

                        <div class="d-flex actions-container"
                            v-if="role !== 'user'">
                            <div class="table-action-text" v-if="model === 'templates' && (permissions.includes('create competition') || permissions.includes('create training'))"
                                @click.prevent="useTemplateHandler($event,td)">
                                <a v-if="model === 'templates' && (permissions.includes('create competition') || permissions.includes('create training'))"
                                @click.prevent="useTemplateHandler($event,td)"
                                class="use-template-link cssTextTemplates"> Use Template</a>
                            </div>
                            <div class="table-action-text" v-if="model === 'templates' && permissions.includes('create template')"
                                @click.prevent="copyTemplateHandler($event,td)">
                                <a v-if="model === 'templates' && permissions.includes('create template')"
                                @click.prevent="copyTemplateHandler($event,td)"
                                class="use-template-link cssTextTemplates"> Copy Template</a>
                            </div>
                            
                            <div class="action-left-cell" v-if="permissions.includes('update '+ name)">
                                <img :src="getActionIcon('edit')" class="penDesign action-icon"
                                :style="model === 'teams' ? (
                                            (td['users_count'] === 0 || td['participants_count'] > 0) ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) :
                                                model === 'templates' ? (td['competitions_count'] > 0 ? {cursor: 'not-allowed'} : {cursor: 'pointer'}): model === 'organizations' ?
                                                (td['users'] > 0 ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) : model === 'competitions' ?
                                                (td['status'] === 'ended' || td['status'] === 'running' ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) :
                                                model === 'trainings' ? (td['status'] === 'ended' || td['status'] === 'running' ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) : {cursor: 'pointer'} "
                                @click.prevent="editOrganization(td)" v-if="permissions.includes('update '+ name)" />
                            </div>
                            <div v-if="model === 'scoreIndividual' && permissions.includes('viewAny userscore')">
                                    <font-awesome-icon
                                    v-if="model === 'scoreIndividual' && permissions.includes('viewAny userscore')"
                                    :icon="['fas', 'plus']" size="sm" class="plusDesign action-icon"
                                    @click.prevent="showCompetitionUsersScore(td)" />
                            </div>
                                
                            <div v-if="model === 'userScoreIndividual' && td.isAnswerd === 1  && td.is_scored !=1 ">
                                <font-awesome-icon
                                    v-if="model === 'userScoreIndividual' && td.isAnswerd === 1  && td.is_scored !=1 "
                                    :icon="['fas', 'plus']" size="sm" class="plusDesign action-icon"
                                    @click.prevent="showCompetitionResultForUsers(td)" />
                            </div>
                            <div v-if="model === 'scoreTeams' && permissions.includes('viewAny userscore')">
                                <font-awesome-icon
                                v-if="model === 'scoreTeams' && permissions.includes('viewAny userscore')"
                                :icon="['fas', 'plus']" size="sm" class="plusDesign action-icon"
                                @click.prevent="showComeptitionTeamNumber(td)" />
                            </div>
                            <div v-if="model === 'teamsScoreCompetition'">
                                <font-awesome-icon v-if="model === 'teamsScoreCompetition'" :icon="['fas', 'plus']"
                                    size="sm" class="plusDesign" @click.prevent="showUserOfTeamsinCompetition(td)" />
                            </div>
                            <div v-if="model === 'usersTeamsScore' && td.isAnswerd === 1  && td.is_scored !=1">
                                <font-awesome-icon
                                    v-if="model === 'usersTeamsScore' && td.isAnswerd === 1  && td.is_scored !=1"
                                    :icon="['fas', 'plus']" size="sm" class="plusDesign action-icon"
                                    @click.prevent="showUSerInTeamsCompetitionScore(td)" />
                            </div>
                            <div class="action-right-cell" v-if="permissions.includes('delete '+ name) && model !== 'organizations' && model !== 'competitions' && model !== 'trainings' && model !== 'templates' && model !== 'teams'">
                                <img :src="getActionIcon('trash')"  class="trashDesign action-icon"
                                :style="td['delateFlag'] === undefined ? {cursor: 'pointer'}  : !td['delateFlag'] ? {cursor: 'not-allowed'} : {cursor:'pointer'}"
                                @click.prevent="deleteOrganization(td)"
                                v-if="permissions.includes('delete '+ name) && model !== 'organizations' && model !== 'competitions' && model !== 'trainings' && model !== 'templates' && model !== 'teams'" />
                            </div> 
                            <div class="action-right-cell" v-if="permissions.includes('delete '+ name) && model === 'teams'">
                                <img :src="getActionIcon('trash')" class="trashDesign action-icon"
                                    :style="model === 'teams' ? ((td['users_count'] === 0 || td['participants_count'] > 0) ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) : {cursor:'pointer'}"
                                    @click.prevent="deleteOrganization(td)"
                                    v-if="permissions.includes('delete '+ name) && model === 'teams'" />
                            </div> 
                                
                            <div class="action-right-cell" v-if="permissions.includes('delete '+ name) && model === 'templates'">
                                <img :src="getActionIcon('trash')" class="trashDesign action-icon"
                                    :style="model === 'templates' ? (td['competitions_count'] > 0 ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) : {cursor:'pointer'}"
                                    @click.prevent="deleteOrganization(td)"
                                    v-if="permissions.includes('delete '+ name) && model === 'templates'" />
                            </div>
                                
                            <div class="action-right-cell" v-if="permissions.includes('delete '+ name) && model === 'organizations'">
                                <img :src="getActionIcon('trash')" class="trashDesign action-icon"
                                    :style="model === 'organizations' ? (td['users'] > 0 ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) : {cursor:'pointer'}"
                                    @click.prevent="deleteOrganization(td)"
                                    v-if="permissions.includes('delete '+ name) && model === 'organizations'" />
                            </div>
                                
                            <div class="action-right-cell" v-if="permissions.includes('delete '+ name) && model === 'competitions'">
                                <img :src="getActionIcon('trash')" class="trashDesign action-icon"
                                    :style="model === 'competitions' ? (td['status'] === 'ended' || td['status'] === 'running' || (td['status'] === 'pending' && (td['number_of_participants'] > 0 || td['number_of_participants_users'] > 0)) ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) : {cursor:'pointer'}"
                                    @click.prevent="deleteOrganization(td)"
                                    v-if="permissions.includes('delete '+ name) && model === 'competitions'" />
                            </div>
                                
                            <div class="action-right-cell" v-if="permissions.includes('delete '+ name) && model === 'trainings'">
                                <img :src="getActionIcon('trash')" class="trashDesign action-icon"
                                    :style="model === 'trainings' ? (td['status'] === 'ended' || td['status'] === 'running' || (td['status'] === 'pending' && (td['number_of_participants'] > 0 || td['number_of_participants_users'] > 0)) ? {cursor: 'not-allowed'} : {cursor: 'pointer'}) : {cursor:'pointer'}"
                                    @click.prevent="deleteOrganization(td)"
                                    v-if="permissions.includes('delete '+ name) && model === 'trainings'" /> 
                            </div>
                        </div>

                        <div v-else style="text-align: end">
                            <router-link
                                v-if="model === 'trainings' && td['status'] !== 'ended' && td['is_user_submit'] === 0"
                                :to="'/viewTrainingUser/'+td['id']" class="checkCssLight">Start
                            </router-link>

                            <router-link
                                v-if="(model === 'trainings' && td['status'] !== 'ended') && td['is_user_submit'] === 1"
                                :to="'/viewTrainingUser/'+td['id']" class="checkCssLight">View Answer Model
                            </router-link>

                            <router-link
                                v-if="model === 'competitions' && td['status'] !== 'ended' && td['is_user_submit'] === 0"
                                :to="'/viewCompetitionUser/'+td['id']" class="checkCssLight">Start
                            </router-link>

                            <router-link
                                v-if="model === 'competitions' && td['status'] !== 'ended' && td['is_user_submit'] === 1"
                                :to="'/viewCompetitionUser/'+td['id']" class="checkCssLight">View
                            </router-link>
                        </div>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <ConfirmationModal v-if="confirmModalFlag" :message="confirmMessage" :confirmBtn="leftBtnText"
        :cancleBtn="rightBtnText" @close="confirmModalFlag = false" title="Delete"
        @close-modal="confirmModalHandler($event, this.model, confirmType)" />

    <CopyTemplateComponent v-if="confirmModalFlagTemplate" :message="confirmMessageTemplate" :template_id="template_id"
        :templateName="templateName" :confirmBtn="leftBtnTextTemplate" :cancleBtn="rightBtnTextTemplate"
        @close="confirmModalFlagTemplate = false"
        @close-modal="copyTemplateModalHandler($event, this.model, confirmTypeTemplate)" />

    <AlartModal v-if="this.showModal" message="please wait for uploading all attachments" imagePath="warning.svg"
        @close-modal="this.showModal = false" />

    <AlartModal v-if="this.showModal2" message="Scored Saved Before" imagePath="warning.svg"
        @close-modal="this.showModal2 = false" />

</template>

<script>
    import AlartModal from "../../views/components/AlartModal";
    import ConfirmationModal from "../../views/components/ConfirmationModal";
    import repository from "../../api-services/repository";
    import CopyTemplateComponent from "../../views/components/CopyTemplateComponent";
    import moment from 'moment';

    export default {
        name: 'table-organization',
        components: {ConfirmationModal, AlartModal , CopyTemplateComponent},
        data() {
            return {
                permissions: [],
                
                confirmModalFlag: false,
                confirmModalFlagTemplate: false,
                confirmMessage: '',
                confirmMessageTemplate: '',
                userId: '',
                leftBtnText: 'Delete',
                leftBtnTextTemplate: '',
                rightBtnText: 'Cancle',
                rightBtnTextTemplate: '',
                confirmType: 'delete',
                confirmTypeTemplate: 'delete',
                template_id: null,
                templateName: null,
                showModal: false,
                showModal2: false,
                role: ''
            }
        },

        mounted: async function () {
            this.permissions = this.$store.state.auth.permissions;
            // console.log(this.permissions);
            this.role = this.$store.state.auth.user.data.role[0];
            this.lightMood = this.$store.state.settings.isLightMood;
            console.log(this.lightMood);
        },
        computed:{
            lightMood(){
                return this.$store.state.settings.isLightMood;
            },
            // NEW LOGIC
    isFourActionsVisible() {
        // 1. Check Model
        if (this.model !== 'templates') return false;

        // 2. Safety check for permissions array
        if (!this.permissions || this.permissions.length === 0) {
            return false; 
        }

        // 3. Definitions (matches your template logic exactly)
        // Check "Use Template"
        const hasUse = this.permissions.includes('create competition') || this.permissions.includes('create training');
        
        // Check "Copy Template"
        const hasCopy = this.permissions.includes('create template');
        
        // Check "Edit" (Note: ensuring 'name' prop exists)
        const hasEdit = this.name && this.permissions.includes('update ' + this.name);
        
        // Check "Delete"
        const hasDelete = this.name && this.permissions.includes('delete ' + this.name);

        // --- DEBUGGING --- 
        // If this prints to your console, you can see which one is false
        // console.log("Model:", this.model);
        // console.log("Has Use:", hasUse);
        // console.log("Has Copy:", hasCopy);
        // console.log("Has Edit:", hasEdit, 'update ' + this.name);
        // console.log("Has Delete:", hasDelete);
        // ------------------

        return hasUse && hasCopy && hasEdit && hasDelete;
    }

        },
        emits: ['sort', 'update'],
        props: ['thead', 'tbody', 'name', 'keys', 'ids', 'updateUrl', 'model', 'deletedName', 'editedName'],
        methods: {
            dateTime(value) {
                return moment(value).format('D-MMM-YYYY');
            },
            getColumnWidth(headerName) {
                const name = headerName ? headerName.toString().toLowerCase() : '';

                switch (name) {
                    case 'date created':
                    case 'created at':
                    
                        return '10%';
                    case 'role name':
                        return '80%';
                    case 'number of users':
                        return '12%';
                    case'username':
                    case 'organization name':
                        return '50%'; 
                    case 'user email':    
                    case 'admin email':
                        return '40%';
                    case 'members':
                    case 'status':
                        return '8%';
                    case 'competition name':
                        return '65%';
                    case 'training name':
                        return '60%';
                    default:
                        return 'auto';
                }
            },
            deleteOrganization: async function (e) {

                let isDelete = false;
                let attachmentsStatus = false;

                if (this.model === 'users') {
                    if (e['entities_count'] > 0) {
                        isDelete = true;
                    }
                }

                if (this.model == 'teams') {
                    if (e['users_count'] == 0) {
                        isDelete = true;
                    }
                }

                if(this.model === 'organizations'){
                    if (e['users'] > 0) {
                        isDelete = true;
                    }
                }

                if(this.model === 'teams'){
                    if (e['participants_count'] > 0) {
                        isDelete = true;
                    }
                }

                if(this.model === 'templates'){
                    if (e['competitions_count'] > 0) {
                        isDelete = true;
                    }
                }

                if(this.model === 'competitions'){
                    if (e['status'] === 'ended' || e['status'] === 'running') {
                        isDelete = true;
                    }

                    if(e['status'] === 'pending' && (e['number_of_participants'] > 0 || e['number_of_participants_users'] > 0)){
                        isDelete = true;
                    }
                }

                if(this.model === 'trainings'){
                    if (e['status'] === 'ended' || e['status'] === 'running') {
                        isDelete = true;
                    }

                    if(e['status'] === 'pending' && (e['number_of_participants'] > 0 || e['number_of_participants_users'] > 0)){
                        isDelete = true;
                    }
                }

                if (!isDelete) {
                    try {
                        if (this.model === 'templates') {
                            attachmentsStatus = await repository.getAttachmentStatus(e.id)
                            if (attachmentsStatus.data) {
                                this.confirmModalFlag = true;
                                this.confirmMessage = 'Are You Sure You Want to Delete This' + this.name + ' ?';
                                this.leftBtnText = 'Delete';
                                this.rightBtnText = 'Cancel';
                                this.confirmType = 'delete';
                                this.userId = e.id;
                            } else {
                                this.showModal = true;
                            }
                        } else {
                            this.confirmModalFlag = true;
                            this.confirmMessage = 'Do you want to delete this ' + this.name + '?';
                            this.leftBtnText = 'Delete';
                            this.rightBtnText = 'Cancel';
                            this.confirmType = 'delete';
                            this.userId = e.id;
                        }

                    } catch (e) {
                        // console.log(e);
                    }
                }
            },
            async editOrganization(e) {
                let isDelete = false;
                let attachmentsStatus = false;
                if (this.model === 'teams') {
                    if (+e['users_count'] === 0) {
                        isDelete = true;
                    }
                }

                if (this.model === 'organizations') {
                    if (+e['users'] > 0) {
                        isDelete = true;
                    }
                }

                if (this.model === 'teams') {
                    if (+e['participants_count'] > 0) {
                        isDelete = true;
                    }
                }

                if (this.model === 'templates') {
                    if (+e['competitions_count'] > 0) {
                        isDelete = true;
                    }
                }

                if (this.model === 'competitions') {
                    if (e['status'] === 'ended' || e['status'] === 'running') {
                        isDelete = true;
                    }
                }

                if (this.model === 'trainings') {
                    if (e['status'] === 'ended' || e['status'] === 'running') {
                        isDelete = true;
                    }
                }

                if (!isDelete) {
                    try {

                        if (this.model === 'templates') {
                            attachmentsStatus = await repository.getAttachmentStatus(e.id)
                            console.log(attachmentsStatus.data)
                            if (attachmentsStatus.data) {
                                this.$router.push({path: `${this.updateUrl}/` + e.id});
                            } else {
                                this.showModal = true;
                            }
                        } else {
                            this.$router.push({path: `${this.updateUrl}/` + e.id});
                        }

                        // this.$store.dispatch('setEditFlag', true);
                    } catch (e) {
                        // console.log(e);
                    }
                }
            },
            sortOrganziation() {
                try {
                    this.$emit('sort');
                } catch (e) {
                    // console.log(e);
                }
            },
            confirmModalHandler: async function (event, model, confirmType) {
                this.confirmModalFlag = false;
                if (event && confirmType === 'delete') {
                    try {
                        let resData = await repository.delete(model, this.userId);
                        if (model === 'teams') {
                            this.$store.dispatch('setSuccessModal', true);
                            this.$store.dispatch('setSueccessMessage', resData.data.message);
                            window.location.href = "/settings/teams";
                        } else if (model === 'users') {
                            if (resData.data.message == 'Cannot Delete Team Leader In Team') {
                                this.$store.dispatch('setErrorModal', true);
                                this.$store.dispatch('setErrorMessage', resData.data.message);
                            } else {
                                this.$emit('update', this.userId);
                                this.$store.dispatch('setSuccessModal', true);
                                this.$store.dispatch('setSueccessMessage', resData.data.message);
                            }
                        } else if (model === 'entities') {
                            if (resData.data.message == 'Cannot Delete Entity Has Users') {
                                this.$store.dispatch('setErrorModal', true);
                                this.$store.dispatch('setErrorMessage', resData.data.message);
                            } else {
                                this.$emit('update', this.userId);
                                this.$store.dispatch('setSuccessModal', true);
                                this.$store.dispatch('setSueccessMessage', resData.data.message);
                            }
                        } else {
                            this.$emit('update', this.userId);
                            this.$store.dispatch('setSuccessModal', true);
                            this.$store.dispatch('setSueccessMessage', resData.data.message);
                        }

                    } catch (e) {
                        this.$store.dispatch('setErrorModal', true);
                        this.$store.dispatch('setErrorMessage', e.response.data.message);
                    }
                } else {
                    if(confirmType === 'useTemplate'){
                        let pageName = null;
                        let pageParams = {template_id: this.template_id};
                        // console.log({pageParams})
                        if (event) { //comptition logic
                            pageName = "create-competition";
                        } else { //training logic
                            pageName = "create-training";
                        }

                        this.$router.push({
                            name: pageName, //use name for router push
                            params: pageParams
                        });
                    }else{
                        this.confirmModalFlag = false;
                    }
                }
            },

        getActionIcon(iconName) {
        try {
            // If lightMood is true, we want the original (dark) icon
            // If lightMood is false (Dark Mode), we want the '-light' (white) icon
            if (this.lightMood) {
                return require(`../../assets/images/${iconName}-light.png`);
            } else {
                return require(`../../assets/images/${iconName}.png`);
            }
        } catch (e) {
            // Fallback to original if light version doesn't exist
            return require(`../../assets/images/${iconName}.png`);
        }
    },

            copyTemplateModalHandler: async function(event, model, confirmType){
                if(confirmType === 'copyTemplate'){
                    if(event){

                        this.confirmModalFlagTemplate = false;
                    }else{
                        this.confirmModalFlagTemplate = false;
                    }

                }else{
                    this.confirmModalFlagTemplate = false;
                }
            },

            useTemplateHandler: async function (event, data) {

                let attachmentsStatus = false;

                attachmentsStatus = await repository.getAttachmentStatus(data.id);
                console.log(attachmentsStatus.data);
                if (attachmentsStatus.data) {
                    this.template_id = data.id;
                    this.confirmModalFlag = true;
                    this.confirmMessage = 'Do you want to use this template for a competition or training?';
                    this.leftBtnText = 'Competition';
                    this.rightBtnText = 'Training';
                    this.confirmType = 'useTemplate';
                } else {
                    this.showModal = true;
                }
            },

            copyTemplateHandler: async function(event , data){
                this.template_id = data.id;
                const response = await repository.show('templates' , this.template_id);
                this.templateName = response.data.data.name + ' ' + 'Copy';
                this.confirmModalFlagTemplate = true;
                this.leftBtnTextTemplate = 'Copy Template';
                this.rightBtnTextTemplate = 'Cancel';
                this.confirmTypeTemplate = 'copyTemplate';
            },

            showCompetitionUsersScore(data) {
                this.$router.push({path: '/users/score/show/' + data.id});
            },
            showCompetitionResultForUsers(data) {
                this.$router.push({path: '/results/show/' + this.$route.params.id + '/' + data.id});
            },
            showComeptitionTeamNumber(data) {
                this.$router.push({path: '/competitions/teams/' + data.id});
            },
            showUserOfTeamsinCompetition(data) {
                // console.log(data);
                this.$router.push({path: '/competitions/teams/users/' + this.$route.params.id + '/' + data.id});
            },
            showUSerInTeamsCompetitionScore(data) {
                this.$router.push({path: '/results/show/' + this.$route.params.id1 + '/' + data.id});
            },
            goToViewCompetition(data){
                if(this.permissions.includes('read competition') && this.permissions.includes('viewAny competition')){
                    this.$router.push({path: '/view-competitions/' + data.id});
                }
            },
            goToViewTraining(data){
                if(this.permissions.includes('read training') && this.permissions.includes('viewAny training')){
                    this.$router.push({path: '/view-trainings/' + data.id});
                }
            },
            getTitleOfThead(data){

            }
        }
    }
</script>

<style scoped>
    .product-details{
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: Poppins, sans-serif;
    }
    .table-actions-header{
        margin-bottom: 0;
    }
    .product-details:hover + .product-details-full {
        position: absolute;
        top: -35px;
        background-color: #002634;
        display: flex;
        padding: 5px 10px;
        border-radius: 5px;
        font-family: Poppins, sans-serif;
    }

    .product-details-full {
        display: none;
    }
    .wide-action-col {
    width: 622px !important;
    min-width: 622px !important;
    max-width: 622px !important;
    box-sizing: border-box; 
}

    .styleCssIndividualOrTeam{
        display: flex;
        width: 15px;
        height: 15px;
        border: 1px solid var(--main-color);
        justify-content: center;
        align-items: center;
        align-content: center;
        text-align: center;
        border-radius: 50%;
        font-size: 12px;
        /*position: relative;*/
        /*top: 5px;*/
    }
    .checkCssLight{
        color: var(--main-color);
    }
    .cssTextTemplates{
        color: var(--main-color);
    }
    .plusDesign {
        background-color: #e65c00;
        padding: 5px;
        border-radius: 50%;
        color: var(--icon-plus-desgin-table);
        cursor: pointer;
    }
.table{
    border-spacing: 10px;
    border-collapse: separate;
}
    .btnSort {
        border: none;
        background-color: transparent;
    }

    .penDesign {
        color: var(--color-text-in-table);
        cursor: pointer;
        width:25px;
    }

    .trashDesign {
        color: var(--color-text-in-table);
        width:22px;
        cursor: pointer;
    }
.tableDesign{
    height: 100%;
    overflow: auto;
}
    table {
        background-color: var(--background-color-data);
    }

    tbody td {
        border-bottom: 1px solid var(--border-color-data-table);
        color: var(--color-text-in-table) !important;
        background-color: var(--table-color-data);
        /*white-space: nowrap;*/
        /*overflow: hidden;*/
        /*text-overflow: ellipsis;*/
        
        padding-left: 1%;
    }

    tbody td a{
        /* border-bottom: 1px solid var(--border-color-data-table); */
        color: var(--color-text-in-table);
        text-decoration: none;
        
    }
    
    td {
        height: 41px !important;
        padding-block: 0 !important;
        LINE-HEIGHT: 35px;
    }

    thead {
        background-image: #37A6A2 !important;
        color: #fff;
    }

    thead th {
        width: auto;
        padding: 6px;
         background-color: #37A6A2 !important;
         border: none;
         border-radius: 10px 10px 0px 0;
         padding-left: 1%;
        /*white-space: nowrap;*/
        /*overflow: hidden;*/
        /*text-overflow: ellipsis;*/
    }

    /*@media only screen and (max-width: 1300px) and (min-width: 1250px) {*/
    /*    tbody td{*/
    /*        white-space: nowrap;*/
    /*        width: 70%;*/
    /*        overflow: hidden;*/
    /*        text-overflow: ellipsis;*/
    /*    }*/
    /*}*/

    /*thead th:nth-of-type(1) {*/
    /*    border-radius: 5px 0px 0px 0px;*/
    /*}*/

    /*thead th:nth-of-type(6) {*/
    /*    border-radius: 0px 5px 0px 0px;*/
    /*}*/

    .use-template-link {
        cursor: pointer;
    }
    .actions-container {
        height:100%;
        width: 100%;
        align-items: center;
        display: grid !important;
        grid-auto-flow: column;
        grid-auto-columns:1fr;
        gap: 10px;
        justify-content: center;
    }
    .actions-container div{
        width:auto;
        background-color: var(--table-color-data);
        border-bottom:1px solid var(--border-color-data-table);
        height: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
    }
    .table-striped > tbody > tr:nth-of-type(odd) > *{
        --bs-table-accent-bg: unset !important;
    }
    .aciton-body-cell{
        max-width:100% ;
        background-color:transparent;
        display: flex;
        align-items: center;
        height: 52px;
        padding: 0;
        border: none;
  }
</style>